// import React, { useState, useEffect } from 'react';
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// const PhotoGalleryModal = ({ setModalVisible, apiData, imageIndex }) => {
//   const [updateIndex, setUpdateIndex] = useState(imageIndex);
//   const [animateClass, setAnimateClass] = useState('slide-in-right');
//   const [prevIndex, setPrevIndex] = useState(imageIndex);

//   const closeModal = () => setModalVisible(false);
//   useEffect(() => {
//     if (updateIndex > prevIndex) {
//       setAnimateClass('slide-in-right');
//     } else {
//       setAnimateClass('slide-in-left');
//     }

//     setPrevIndex(updateIndex);
//     const timer = setTimeout(() => {
//       setAnimateClass('');
//     }, 1000);

//     return () => clearTimeout(timer);
//   }, [updateIndex]);

//   return (
//     <>
//       <div className="fixed inset-0 z-50 flex items-center justify-center">
//         <div className="fixed inset-0 bg-black opacity-70" onClick={closeModal}></div>

//         <div className="relative rounded-lg p-2 max-w-3xl w-full">
//           <div className="slider-container rounded-lg relative flex justify-center items-center">
//             <div className="w-full">
//               <div>
//                 <img
//                   className={`w-full xl:h-[600px] md:h-[450px] xss:h-[300px] rounded-lg`}
//                   src={`data:image/jpeg;base64,${apiData[updateIndex - 1]?.doc}`}
//                   alt="Banner"
//                 />
//               </div>

//               <button
//                 className="absolute left-2 top-1/2 transform -translate-y-1/2 text-white p-2 rounded"
//                 type="button"
//                 onClick={() => setUpdateIndex(updateIndex !== 1 ? updateIndex - 1 : updateIndex + 1)}
//               >
//                 <ArrowBackIosIcon />
//               </button>

//               <button
//                 className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white p-2 rounded"
//                 type="button"
//                 onClick={() => setUpdateIndex(apiData?.length !== updateIndex ? updateIndex + 1 : 1)}
//               >
//                 <ArrowForwardIosIcon />
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default PhotoGalleryModal;

import React, { useState, useEffect } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const PhotoGalleryModal = ({ setModalVisible, apiData, imageIndex }) => {
  const [updateIndex, setUpdateIndex] = useState(imageIndex);
  const [prevIndex, setPrevIndex] = useState(imageIndex);

  const closeModal = () => setModalVisible(false);

  useEffect(() => {
    setPrevIndex(updateIndex);
  }, [updateIndex]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black opacity-70" onClick={closeModal}></div>

      <div className="relative rounded-lg p-2 max-w-3xl w-full">
        <div className="slider-container rounded-lg relative flex justify-center items-center">
          <div className="w-full">
            <img
              className="w-full xl:h-[600px] md:h-[450px] xss:h-[300px] rounded-lg"
              src={`data:image/jpeg;base64,${apiData?.[updateIndex - 1]?.doc}`}
              alt="Banner"
            />

            <button
              className="absolute left-2 top-1/2 transform -translate-y-1/2 text-white p-2 rounded"
              type="button"
              onClick={() => setUpdateIndex(updateIndex > 1 ? updateIndex - 1 : apiData.length)}
            >
              <ArrowBackIosIcon />
            </button>

            <button
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white p-2 rounded"
              type="button"
              onClick={() => setUpdateIndex(updateIndex < apiData.length ? updateIndex + 1 : 1)}
            >
              <ArrowForwardIosIcon />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhotoGalleryModal;
